import { Cell, Row } from '@library/components/table';
import type { TransformedUnsettlementsActionsResponse } from '@library/types/unsettlements';
import { UNSETTLEMENTS_TABLE_HEADER } from '@bo-constants/unsettlements';
import { cn } from '@library/component-utils/cn';

export interface UnsettlementRowProps {
  rowData: TransformedUnsettlementsActionsResponse;
}

export const UnsettlementsRow = ({ rowData }: UnsettlementRowProps) => {
  const {
    actionId,
    adminName,
    completedDate,
    completedTime,
    createdDate,
    createdTime,
    reason,
    updatedDate,
    updatedTime,
    projectionId
  } = rowData;

  const findCellWidth = (column: string) => {
    const cellWidth = UNSETTLEMENTS_TABLE_HEADER.find(
      (header) => header.column === column
    )?.width;
    return cellWidth;
  };

  return (
    <Row
      rowClassName="bg-soFresh-110 hover:bg-soFresh-130"
      dataTestId={`unsettlements-row-${actionId}`}
    >
      {/* ID */}
      <Cell
        cellClassName={findCellWidth('actionId')}
        data-testid="unsettlements-cell-actionId"
      >
        <p className="text-soClean-160">{actionId}</p>
      </Cell>

      {/* PROJECTION */}
      <Cell
        cellClassName={findCellWidth('projectionId')}
        data-testid="unsettlements-cell-projectionId"
      >
        <p className="text-soClean-100">{projectionId}</p>
      </Cell>

      {/* ADMIN */}
      <Cell
        cellClassName={findCellWidth('adminName')}
        data-testid="unsettlements-cell-adminName"
      >
        <div className="text-soClean-100">{adminName}</div>
      </Cell>

      {/* CREATED AT */}
      <Cell
        cellClassName={cn(
          findCellWidth('createdAt') || '',
          'flex flex-col items-start'
        )}
        data-testid="unsettlements-cell-createdAt"
      >
        <p className="text-soClean-100">{createdDate}</p>
        <p className="text-soClean-160">{createdTime}</p>
      </Cell>

      {/* UPDATED AT */}
      <Cell
        cellClassName={cn(
          findCellWidth('updatedAt') || '',
          'flex flex-col items-start'
        )}
        data-testid="unsettlements-cell-updatedAt"
      >
        <p className="text-soClean-100">{updatedDate}</p>
        <p className="text-soClean-160">{updatedTime}</p>
      </Cell>

      {/* REASON */}
      <Cell
        cellClassName={findCellWidth('reason')}
        data-testid="unsettlements-cell-reason"
      >
        <div className="text-soClean-160">{reason}</div>
      </Cell>

      {/* FINISHED AT */}
      <Cell
        cellClassName={cn(
          findCellWidth('completedOn') || '',
          'flex flex-col items-start'
        )}
        data-testid="unsettlements-cell-finishedAt"
      >
        <p className="text-soClean-100 text-left">{completedDate}</p>
        <p className="text-soClean-160">{completedTime}</p>
      </Cell>
    </Row>
  );
};
